import React from 'react';
import { FadeIn } from './FadeIn';
export function UrgencySection() {
  return <section className="bg-brand-green py-16 md:py-24 px-4 md:px-6 text-center" data-id="element-147">
      <div className="max-w-2xl mx-auto" data-id="element-148">
        <FadeIn data-id="element-149">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-white/40 mb-8" data-id="element-150">
            Última oportunidad en esta página
          </p>

          <div className="space-y-3 mb-3" data-id="element-151">
            <p className="font-serif italic text-white/85 text-[18px] md:text-[22px] leading-[1.7]" data-id="element-152">
              Esto no es un curso. No tenés que estudiar nada ni esperar a
              terminar un módulo para aplicarlo.
            </p>
            <p className="font-serif italic text-white/85 text-[18px] md:text-[22px] leading-[1.7]" data-id="element-153">
              Comprás hoy, descargás hoy, y mañana entrás a la primera consulta
              con todo listo.
            </p>
          </div>

          <p className="text-white/60 text-[15px] leading-relaxed mt-7 mb-10" data-id="element-154">
            Cada hora que seguís improvisando es una hora que le estás regalando
            a alguien que no te la paga.
          </p>

          <a href="#pricing" className="inline-block bg-brand-gold hover:bg-brand-gold-dark text-white font-semibold text-[15px] md:text-base px-9 md:px-10 py-4 md:py-[18px] rounded-md tracking-wide transition-all hover:-translate-y-0.5 shadow-[0_4px_24px_rgba(0,0,0,0.25)] hover:shadow-[0_8px_32px_rgba(0,0,0,0.3)]" data-id="element-155">
            → QUIERO MI KIT AHORA
          </a>
        </FadeIn>
      </div>
    </section>;
}